import { getEncryptParams } from 'src/keycloak';
import {
  Builder,
  appendFormData,
  decryptResponse,
  getHeaders,
  getQueryString,
  serializeErrorResponse
} from './utils';
import { IS_ENCRYPTION_ENABLED } from 'src/config';
import { DataApiInputParams } from 'src/types/api';
import { getPayload } from 'src/utils/encryption';

export default (builder: Builder) => {
  return {
    getRoles: builder.query({
      async queryFn(
        arg: DataApiInputParams | void,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const queryString = getQueryString(arg && arg.params);
        let url = `keycloak/ResourceRole${
          queryString.length ? '?' + queryString : ''
        }`;

        if (IS_ENCRYPTION_ENABLED) {
          url = `${url}${queryString.length ? '&' : '?'}payload=${btoa(
            getPayload('', getEncryptParams())
          )}`;
        }

        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Roles']
    }),
    createRole: builder.mutation({
      async queryFn(
        args: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `keycloak/ResourceRole`;
        let formData = appendFormData(args.params);

        return fetchWithBQ({
          url: url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Roles']
    }),
    deleteRole: builder.mutation({
      async queryFn(
        args: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `keycloak/ResourceRole`;
        let formData = appendFormData(args.params);
        return fetchWithBQ({
          url,
          method: 'DELETE',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Roles']
    }),
    updateRole: builder.mutation({
      async queryFn(args: DataApiInputParams, _, __, fetchWithBQ) {
        let url = `keycloak/ResourceRole`;
        let formData = appendFormData(args.params);

        return fetchWithBQ({
          url: url,
          method: 'PATCH',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Roles']
    })
  };
};
